/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {SearchStateInterface} from '@/store/modules/search/types';
import {actions} from '@/store/modules/search/actions';
import {getters} from '@/store/modules/search/getters';
import {mutations} from '@/store/modules/search/mutations';


export const state: SearchStateInterface = {
    searchIssue: {
        term: '',
        gameId: undefined,
        results: [],
        totalResults: -1,
        pagination: {},
    },
    searchCustomerSupport: {
        term: '',
        results: [],
    },
};

const namespaced: boolean = true;

export const searchStateModule: Module<SearchStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
};
